export function addDaysToDate(date: Date, days_to_add: number) {
  date.setDate(date.getDate() + days_to_add);
  return date;
}
